if (!customElements.get('close-details')) {
  class CloseDetails extends HTMLElement {
    constructor() {
      super();
    }

    closeDetails() {
      const details = this.closest('details');
      if (details) {
        details.removeAttribute('open');
        bodyScroll.clear();
      }
    }

    connectedCallback() {
      this.button = this.querySelector('button');
      this.button.addEventListener('click', this.closeDetails.bind(this));
    }
  }

  customElements.define('close-details', CloseDetails);
}
